import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postMBMPointData } from "services/ConfigServices";
import Chart from "react-google-charts";
import moment from "moment";
import "./sankey.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));


const colors = ['#a6cee3', '#b2df8a', '#fb9a99', '#fdbf6f',
  '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'];

const options = {
  // height: 400,
  tooltip: { isHtml: true },
  sankey: {
    node: {
      colors: colors,
      interactivity: true,
    },
    link: {
      colorMode: 'gradient',
      colors: colors
    }
  }
};


function SankeyDialog(props) {

  const { closeModal, refetch, tree, currentItem, pointdata } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'week').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const [pointlist, setPointlist] = useState([]);
  const [avobpointlist, setAvobpointlist] = useState([]);
  const [unit, setUnit] = useState('kWh');

  const [data, setData] = useState([]);

  const { chartIdGroup } = advancedSearchContext;
  const classes = useStyles();

  useEffect(() => {
    let starttree = tree;
    if (currentItem) {
      let startnode = lookForItemInTree(tree);
      if (startnode?.avobitem?.parameters?.unit)
        setUnit(startnode.avobitem.parameters.unit)
      console.log(startnode);
      if (startnode && startnode.children && startnode.children.length > 0)
        starttree = startnode.children;
    }
    if (starttree && starttree.length > 0) {
      let pointlisttmp = [];
      getPointListFromLeaf(starttree, pointlisttmp);
      let avobpointlisttmp = [];
      pointlisttmp.forEach((pt) => {
        if (pt.avobitem.parameters.valuetype === 'point') {
          let pointtmp = pointdata.find((ptd) => ptd.id == pt.avobitem.parameters.value);
          if (pointtmp)
            avobpointlisttmp.push(pointtmp);
        }
      })
      if (pointlisttmp.length > 0)
        getData(avobpointlisttmp, 0);
      setPointlist(pointlisttmp);
    }
  }, []);

  const getData = (avobpointlisttmp) => {
    let pointids = avobpointlisttmp.map((point) => {
      return "" + point.pointid;
    })
    let request = {
      datebegin,
      dateend,
      method: '1d',
      pointids,
      app: "" //to delete after maj
    }
    setLoading(true);
    axios
      .post(postMBMPointData(),
        request,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        })
      .then((res) => {
        setLoading(false);
        avobpointlisttmp.forEach((point) => {
          console.log(point);
          if (res.data[point.pointid]) {
            let sorteddata = res.data[point.pointid].sort((a, b) => a.date - b.date);
            if (sorteddata) {
              let total = 0;
              sorteddata.forEach((val) => total += Number(val.value));
              point.total = total;
            }
          }
        });
        setAvobpointlist(avobpointlisttmp);
      });
  }

  useEffect(() => {
    if (avobpointlist && avobpointlist.length > 0 && pointlist && pointlist.length > 0) {
      let datatmp = [];
      let node2 = {};
      datatmp.push([{
        type: "string",
        label: "From",
        id: "a"
      },
      {
        type: "string",
        label: "To",
        id: "b"
      },
      {
        type: "number",
        label: "Kwh",
        id: "c"
      },
      {
        type: "string",
        role: "tooltip",
        id: "d",
        p: { html: true }
      }]);
      let alreadyagg = [];
      pointlist.forEach((pt) => {
        if (pt.avobitem.parameters.usage && pt.avobitem.parameters.usage.length > 0) {
          //leaf already in agg will be detected here, since father is before in pointlist
          if (pt.avobitem.parameters.valuetype === 'point' && !alreadyagg.find((apt) => apt.id === pt.id)) {
            let coef = pt.avobitem.parameters.coef || 1;
            let val = avobpointlist.find((avobpt) => avobpt.id == pt.avobitem.parameters.value)?.total * coef;
            console.log(pt.avobitem.parameters, coef);
            if (val) {
              datatmp.push([pt.label, pt.avobitem.parameters.usage[0], Number(val)]);
              if (pt.avobitem.parameters.location) {
                if (!node2[pt.avobitem.parameters.usage[0]])
                  node2[pt.avobitem.parameters.usage[0]] = {};
                if (!node2[pt.avobitem.parameters.usage[0]][pt.avobitem.parameters.location])
                  node2[pt.avobitem.parameters.usage[0]][pt.avobitem.parameters.location] = 0;
                node2[pt.avobitem.parameters.usage[0]][pt.avobitem.parameters.location] += Number(val);
              }
            }
          }
          else if (pt.avobitem.parameters.valuetype === 'agg' && pt.children && pt.children.length > 0) {
            //we cumulate from here
            let label = pt.label;
            let usage = pt.avobitem.parameters.usage[0];
            let location = pt.avobitem.parameters.location;
            let coef = pt.avobitem.parameters.coef || 1;
            if (location) {
              let starttree = pt.children;
              let childrenpointlist = [];
              getPointListFromLeaf(starttree, childrenpointlist);
              let aggval = 0;
              childrenpointlist.forEach((childpt) => {
                if (childpt.avobitem.parameters.valuetype === 'point') {
                  let val = avobpointlist.find((avobpt) => avobpt.id == childpt.avobitem.parameters.value)?.total * coef;
                  aggval += val;
                  alreadyagg.push(childpt);
                }
              });
              datatmp.push([label, usage, Number(aggval)]);
              if (!node2[usage])
                node2[usage] = {};
              if (!node2[usage][location])
                node2[usage][location] = 0;
              node2[usage][location] += Number(aggval);

            }
          }
        }

      });
      Object.keys(node2).forEach(function (key) {
        let usage = node2[key];
        Object.keys(usage).forEach(function (key2) {
          datatmp.push([key, key2, usage[key2]]);
        });
      });
      datatmp = datatmp.map((d) => {
        let newd = [...d];
        if (d.length == 3) {
          newd.push(
            "<div class=\"avob-tooltip\">" +
            "<p><b>'" + d[0] + "'</b> vers <b>'" + d[1] + "'</b></p>" +
            "<p>" + new Intl.NumberFormat('fr-FR').format(d[2]) + " " + unit + "</p>" +
            "</div>"
          );
        }

        return newd;
      });
      setData(datatmp);
    }


  }, [pointlist, avobpointlist, unit]);

  const lookForItemInTree = (tree) => {
    let startnode = '';
    tree.forEach((node) => {
      if (!startnode) {
        if (currentItem && node.id === currentItem) {
          startnode = node;
        }
        else if (node.children && node.children.length > 0)
          startnode = lookForItemInTree(node.children)
      }
    });
    return startnode;
  }

  const getPointListFromLeaf = (tree, pointlist) => {
    tree.forEach((node) => {
      //Important to add father agg before children, so that we will detect if children already in agg in display
      if ((node.avobitem?.parameters?.valuetype === 'point' && node.avobitem?.parameters?.value)
        || node.avobitem?.parameters?.valuetype === 'agg') {
        pointlist.push(node);
      }
      if (node.children && node.children.length > 0)
        getPointListFromLeaf(node.children, pointlist);
    });
  }

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          {
            loading ?
              <GridItem xs={12} sm={12} md={12} lg={12}><div style={{ paddingTop: "12px", marginLeft: "35%" }}>Récupération des données en cours...</div></GridItem>
              :

              <GridItem xs={12} sm={12} md={12} lg={12}>

                {
                  (data && data.length > 1) ?
                    <Chart
                      chartType="Sankey"
                      width="100%"
                      height="500px"
                      data={data}
                      options={options}
                    />
                    : <>
                    </>
                }

              </GridItem>


          }
        </GridContainer>
      </form>
    </>
  );
}

export default SankeyDialog;
